import { createBrowserRouter, Navigate } from "react-router-dom"
import { RequireAnon, RequireAuth, RequireSuperuser } from "@/components/auth/route-guards"
import { AdminLayout } from "@/components/admin/layout"
import { DashboardLayout } from "@/components/dashboard/layout"
import { AuthLayout } from "@/components/auth/auth-layout"
import { LoginPage } from "@/pages/auth/login"
import { SignupPage } from "@/pages/auth/signup"
import { ForgotPasswordPage } from "@/pages/auth/forgot-password"
import { ResetPasswordPage } from "@/pages/auth/reset-password"
import { OnboardingPage } from "@/pages/auth/onboarding"
import { AcceptInvitePage } from "@/pages/auth/accept-invite"
import { LandingPage } from "@/pages/marketing/landing"
import { TermsPage } from "@/pages/legal/terms"
import { PrivacyPage } from "@/pages/legal/privacy"
import { KvkkPage } from "@/pages/legal/kvkk"
import { CareersOrgPage } from "@/pages/careers/org"
import { CareersJobPage } from "@/pages/careers/job"
import { DashboardHome } from "@/pages/dashboard/home"
import { JobsPage } from "@/pages/dashboard/jobs"
import { JobDetailPage } from "@/pages/dashboard/job-detail"
import { JobNewPage } from "@/pages/dashboard/job-new"
import { JobEditPage } from "@/pages/dashboard/job-edit"
import { CandidatesPage } from "@/pages/dashboard/candidates"
import { CandidateDetailPage } from "@/pages/dashboard/candidate-detail"
import { PipelinePage } from "@/pages/dashboard/pipeline"
import { InboxPage } from "@/pages/dashboard/inbox"
import { InterviewsPage } from "@/pages/dashboard/interviews"
import { SettingsPage } from "@/pages/dashboard/settings"
import { AdminSettingsPage } from "@/pages/admin/settings"
import { NotFoundPage } from "@/pages/not-found"

export const router = createBrowserRouter([
  { path: "/", element: <LandingPage /> },
  { path: "/legal/terms", element: <TermsPage /> },
  { path: "/legal/privacy", element: <PrivacyPage /> },
  { path: "/legal/kvkk", element: <KvkkPage /> },
  { path: "/careers/:orgSlug", element: <CareersOrgPage /> },
  { path: "/careers/:orgSlug/:jobSlug", element: <CareersJobPage /> },

  {
    element: <RequireAnon><AuthLayout /></RequireAnon>,
    children: [
      { path: "/login", element: <LoginPage /> },
      { path: "/signup", element: <SignupPage /> },
      { path: "/forgot-password", element: <ForgotPasswordPage /> },
      { path: "/reset-password", element: <ResetPasswordPage /> },
    ],
  },
  {
    path: "/onboarding",
    element: (
      <RequireAuth>
        <AuthLayout />
      </RequireAuth>
    ),
    children: [{ index: true, element: <OnboardingPage /> }],
  },
  { path: "/accept-invite/:token", element: <AcceptInvitePage /> },

  {
    path: "/dashboard",
    element: (
      <RequireAuth>
        <DashboardLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <DashboardHome /> },
      { path: "jobs", element: <JobsPage /> },
      { path: "jobs/new", element: <JobNewPage /> },
      { path: "jobs/:id/edit", element: <JobEditPage /> },
      { path: "jobs/:id", element: <JobDetailPage /> },
      { path: "candidates", element: <CandidatesPage /> },
      { path: "candidates/:id", element: <CandidateDetailPage /> },
      { path: "pipeline", element: <PipelinePage /> },
      { path: "inbox", element: <InboxPage /> },
      { path: "interviews", element: <InterviewsPage /> },
      { path: "settings/*", element: <SettingsPage /> },
    ],
  },

  {
    path: "/admin",
    element: (
      <RequireSuperuser>
        <AdminLayout />
      </RequireSuperuser>
    ),
    children: [
      { index: true, element: <AdminSettingsPage /> },
    ],
  },

  { path: "*", element: <NotFoundPage /> },
  // Backwards-compat aliases
  { path: "/dashboard/*", element: <Navigate to="/dashboard" replace /> },
])
